<template>
    <fragment>
    <div class="study-item v3_box_teal font_Montserrat position-relative">
      <div class="v3_box_teal_header shadow-none py-2 header-tabs">
        <b-row align-v="center">
            <b-col cols="4" sm="4" xs="12">
                <b-row class="h-100">
                <b-col cols="12" sm="8">
                    <div class="h-100 d-flex align-items-center">
                    <h2 class="mb-0 font_size_1000rem">
                        <span>Monitor and manage <br> connected candidates.</span>
                    </h2>
                    </div>
                </b-col>
                </b-row>
            </b-col>

            <b-col cols="4" sm="4" xs="12">
                <b-row class="h-100">
                <b-col cols="12" sm="8">
                    <div class="h-100 d-flex align-items-center">
                    <h2 class="mb-0 font_size_1000rem">
                        <span>Find and connect <br> to interested candidates.</span>
                    </h2>
                    </div>
                </b-col>
                </b-row>
            </b-col>

            <b-col cols="4" sm="4" xs="12">
                <b-row class="h-100">
                <b-col cols="12" sm="8">
                    <div class="h-100 d-flex align-items-center">
                    <h2 class="mb-0 font_size_1000rem">
                        <span>Maximize  the appeal <br> of your job opportunity.</span>
                    </h2>
                    </div>
                </b-col>
                </b-row>
            </b-col>
        </b-row>
      </div>
    </div> 
    </fragment>
    
  </template>
  
  <script>
  
  export default {
    name: 'RecruiterHeader',
  };
  </script>
  
  <style scoped>
    .header-tabs {
       padding: 0 15px;
    }
    .header-tabs h2 {
        text-transform: uppercase;
        letter-spacing: 1.4px;
        text-align: center;
    }
    .header-tabs span{
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        padding-left: 15px;
        height: 50px;
        text-transform: uppercase;
        letter-spacing: 1.4px;
        color: #016178;
        border: 0;
        border-right-color: currentcolor;
        border-right-style: none;
        border-right-width: 0px;
        border-radius: 0;
    }
    .h-100{
        justify-content: center;
    }
    .study-item .v3_box_teal{
        margin-bottom: 20px;
    }
    @media (max-width:767px){
        .header-tabs span{
            height: unset;
            padding-bottom: 20px;;
        }
        .header-tabs .row{
            flex-flow: column;
        }
    }

   
    </style>
    

   